import * as types from "./mudation-types"
import moment from "moment"
export default {
  [types.save_routes](state: any, obj: any) {
    state.routes = obj
  },
  [types.show_route](state: any, obj: any) {
    const hasRoute = state.routes.findIndex((el: any) => el.id == obj.id)
    if (hasRoute >= 0) {
      state.routes.splice(hasRoute, 1, obj)
    } else {
      state.routes.push(obj)
    }
    state.route = obj
  },
  [types.update_status](state: any, obj: any) {
    for (const index in state.routes) {
      if (state.routes[index].id == obj.id) {
        state.routes.splice(index, 1, {
          ...state.routes[index],
          ...obj,
        })
      }
    }
  },
  [types.activate_routes](state: any, ids: any) {
    for (const index in state.routes) {
      if (ids.includes(state.routes[index].id)) {
        state.routes.splice(index, 1, {
          ...state.routes[index],
          in_field: 1,
          time_out: moment().format("YYYY-MM-DD HH:mm:ss"),
        })
      }
    }
  },
  [types.disable_routes](state: any, ids: any) {
    for (const index in state.routes) {
      if (ids.includes(state.routes[index].id)) {
        state.routes.splice(index, 1, {
          ...state.routes[index],
          at_base: 1,
          time_in: moment().format("YYYY-MM-DD HH:mm:ss"),
        })
      }
    }
  },
}
